import { object, string } from 'yup';
import { useEsigningAuthenticationModes } from 'app/domains/esigning/hooks/useEsigningAuthenticationModes';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { getAuthenticationModeField, getEmailField, getMobileField, getRequiredString, } from 'app/domains/esigning/utils/formSchemaFields';
export const useGetSchema = (options) => {
    const { properties } = useEsigningProviderMetadata();
    const { allowDuplicateEmails } = properties;
    const { authenticationModes } = useEsigningAuthenticationModes();
    const hasAuthenticationModeSlugs = authenticationModes.map((mode) => mode.slug);
    const requiredString = getRequiredString();
    const emailField = getEmailField(Object.assign(Object.assign({}, options), { allowDuplicateEmails }));
    const mobileField = getMobileField();
    const authenticationModeField = getAuthenticationModeField(hasAuthenticationModeSlugs);
    return object().shape({
        email: emailField,
        mobile: mobileField,
        authenticationMode: authenticationModeField,
        firstName: requiredString,
        lastName: requiredString,
        label: string(),
        title: string(),
    });
};
